import { render, staticRenderFns } from "./yjfk.vue?vue&type=template&id=12bbb074&scoped=true&"
import script from "./yjfk.vue?vue&type=script&lang=js&"
export * from "./yjfk.vue?vue&type=script&lang=js&"
import style0 from "./yjfk.vue?vue&type=style&index=0&id=12bbb074&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bbb074",
  null
  
)

export default component.exports